// extracted by mini-css-extract-plugin
export default {"section":"SynthControls_section__QrXTN","container":"SynthControls_container__MFQvT","header":"SynthControls_header__1sHHt","controlsFrame":"SynthControls_controlsFrame__VrCME"};